export function initGalleryLightbox() {
    const items = Array.from(document.querySelectorAll(".civial-project-gallery__item"));
    if (!items.length)
        return;
    const lightbox = document.getElementById("civial-lightbox");
    const stage = document.getElementById("lightbox-stage");
    const captEl = document.getElementById("lightbox-caption");
    const counter = document.getElementById("lightbox-counter");
    const btnClose = document.getElementById("lightbox-close");
    const btnPrev = document.getElementById("lightbox-prev");
    const btnNext = document.getElementById("lightbox-next");
    if (!lightbox || !stage || !btnClose || !btnPrev || !btnNext)
        return;
    const media = items.map((el) => ({
        type: (el.dataset.type || "image"),
        src: el.dataset.src || "",
        poster: el.dataset.poster || "",
        caption: el.dataset.caption || "",
    }));
    const total = media.length;
    let current = 0;
    function open(index) {
        current = ((index % total) + total) % total;
        render();
        lightbox.hidden = false;
        document.body.style.overflow = "hidden";
        lightbox.focus();
    }
    function close() {
        stopVideo();
        lightbox.hidden = true;
        document.body.style.overflow = "";
        const focused = items[current];
        if (focused)
            focused.focus();
    }
    function navigate(delta) {
        stopVideo();
        open(current + delta);
    }
    function stopVideo() {
        const vid = stage.querySelector("video");
        if (vid) {
            vid.pause();
            vid.src = "";
        }
    }
    function render() {
        const m = media[current];
        stage.innerHTML = "";
        const wrap = document.createElement("div");
        wrap.className = "civial-lightbox__media";
        if (m.type === "video") {
            const vid = document.createElement("video");
            vid.className = "civial-lightbox__video";
            vid.src = m.src;
            vid.controls = true;
            vid.autoplay = true;
            vid.playsInline = true;
            if (m.poster)
                vid.poster = m.poster;
            wrap.appendChild(vid);
        }
        else {
            const img = new Image();
            img.className = "civial-lightbox__image";
            img.alt = m.caption;
            const spinner = document.createElement("div");
            spinner.className = "civial-lightbox__spinner";
            wrap.appendChild(spinner);
            img.onload = () => {
                spinner.remove();
                wrap.appendChild(img);
            };
            img.src = m.src;
        }
        stage.appendChild(wrap);
        if (captEl) {
            captEl.textContent = m.caption;
            captEl.hidden = !m.caption;
        }
        if (counter)
            counter.textContent = `${current + 1} / ${total}`;
        btnPrev.hidden = total <= 1;
        btnNext.hidden = total <= 1;
    }
    // Item click / keyboard
    items.forEach((el, i) => {
        el.addEventListener("click", () => open(i));
        el.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                open(i);
            }
        });
    });
    btnClose.addEventListener("click", close);
    btnPrev.addEventListener("click", () => navigate(-1));
    btnNext.addEventListener("click", () => navigate(1));
    // Keyboard nav
    lightbox.addEventListener("keydown", (e) => {
        switch (e.key) {
            case "Escape":
                close();
                break;
            case "ArrowLeft":
                navigate(-1);
                break;
            case "ArrowRight":
                navigate(1);
                break;
        }
    });
    // Backdrop click
    lightbox.addEventListener("click", (e) => {
        if (e.target === lightbox)
            close();
    });
    // Swipe support (touch)
    let touchStartX = 0;
    lightbox.addEventListener("touchstart", (e) => {
        touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener("touchend", (e) => {
        const delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 50)
            navigate(delta < 0 ? 1 : -1);
    }, { passive: true });
}
